import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaDollarSign, FaExternalLinkAlt } from "react-icons/fa";
import { GoHome } from "react-icons/go";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UseAuth } from "src/auth/AuthContext";
import { BsCoin, BsFillKeyFill, BsGraphUp } from "react-icons/bs";
import {
  classNames,
  getProfileDefaultImage,
  getRoleName,
  validateRouteRole,
} from "src/helpers/mixins";
import { GiCalculator, GiCrownCoin, GiWorld } from "react-icons/gi";
import { MdOutlineLogout, MdOutlineSchedule } from "react-icons/md";
import { useState } from "react";
import ConfirmationLogout from "src/components/Shared/ConfirmationLogout";
import { FaPerson } from "react-icons/fa6";
import { TbUserCircle } from "react-icons/tb";
import { GrConfigure } from "react-icons/gr";
import { SiHtmlacademy } from "react-icons/si";


const CashierSidebar = () => {
  const { user } = UseAuth();
  const navigate = useNavigate();    
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  return (
    <div
      className={`w-full md:w-fit pt-6 bg-white  fixed  flex-shrink flex-grow-0 `}
    >
      <div className="pl-8 flex gap-2 px-2 items-center text-black justify-start flex mb-2 font-semibold relative">
        <div
          className="w-8 h-8 bg-cover bg-center rounded-full"
          onClick={() => navigate(`/usuario/${user?.id}`)}
          style={{
            backgroundImage: `url(${
              (user?.photoUrl?.length || 0) > 0
                ? process.env.REACT_APP_PROFILEPICTURE +
                  (user?.photoUrl || "")
                : getProfileDefaultImage()
            })`,
          }}
        ></div>        
        <div onClick={() => navigate(`/usuario/${user?.id}`)}
         className="ellipsis cursor-pointer  hover:underline text-xs max-w-90 font-semibold">
          {user?.nickname ? 
            <div className="uppercase">
              {user?.nickname}
            </div>
         :  
           <div className="text-ellipsis overflow-hidden">
           {user?.fullname?.split(" ")![0]}
           </div>
        }
        <div className="text-xs">
          {getRoleName(user?.role || 'user')}
        </div>
         </div>
      </div>
      <MenuListedCashier close={ () => null } />
      <ConfirmationLogout
        show={showConfirmation}
        cancel={() => setShowConfirmation(false)}
        confirm={() => navigate('/salir')}
      />

    </div>
  );
};
export default CashierSidebar;

type ParamsMenuLC = {
  close(): void
}
export const MenuListedCashier = ({close}:ParamsMenuLC) => {
  const { user } = UseAuth()
  const enableRoutes = validateRouteRole(user?.role || '');
  const location = useLocation();
  const pathName = location.pathname.toString();
  const navigate = useNavigate()
  const { t } = useTranslation()

  
  const go = (to:string) => {
    close()
    navigate(to)
  }
  return (

    <div className={"relative md:sticky  h-full  md:top-0 md:my-0 transition-all"}>
    <ul className="">
      <LiDev
        name={"Dashboard"}
        to="/cashier/home"
        pathName={pathName}
        go={go}
        Icon={
          <>
            <GoHome size={20} className="text-black" />
          </>
        }
      />
      <LiDev
        name={t("profiletext")}
        to={`/usuario/${user?.id}`}
        pathName={pathName}
        go={go}
        Icon={
          <>
            <TbUserCircle size={20} className="text-black" />
          </>
        }
      />      
      <LiDev
        name={'Mi horario'}
        to={`/cashier/horario`}
        pathName={pathName}
        go={go}
        Icon={
          <>
            <MdOutlineSchedule size={20} className="text-black" />
          </>
        }
      /> 
      <LiDev
        name={t("cashier.clients")}
        to="/cashier/clientes"
        pathName={pathName}
        go={go}
        Icon={
          <>
            <FaPerson size={20} className="text-black" />
          </>
        }
      />     
      <LiDev
        name={t("cashier.processors")}
        to="/cashier/procesadores"
        pathName={pathName}
        go={go}
        Icon={
          <>
            <GiWorld size={20} className="text-black" />
          </>
        }
      />    
      <LiDev
          
          name={"Mis cuentas"}
          to="/cashier/recibir-dinero"
          pathName={pathName}
          go={go}
          Icon={
            <>
              <BsCoin size={20} className="text-black" />
            </>
          }
        />
      <LiDev
        name={t("Precio dolar")}
        to="/cashier/dolar"
        pathName={pathName}
        go={go}
        Icon={
          <>
            <FaDollarSign size={20} className="text-black" />
          </>
        }
      />    

       <LiDev
        name={t("cashier.calculator")}
        to="/cashier/calculadora"
        pathName={pathName}
        go={go}
        Icon={
          <>
            <GiCalculator size={20} className="text-black" />
          </>
        }
      />
      <LiDev
        name={"Mis Coins"}
        to="/cashier/movimientos"
        pathName={pathName}
        go={go}
        Icon={
          <>
            <GiCrownCoin size={20} className="text-amber-400" />
          </>
        }
      />      
      <LiDev
        name={"Recargar Coins"}
        to="/cashier/recargar-coins/formulario"
        pathName={pathName}
        go={go}
        Icon={
          <>
            <GiCrownCoin size={20} className="text-amber-400" />
          </>
        }
      />
      <LiDev
        name={t("cashier.ranges")}
        to="/cashier/rangos"
        pathName={pathName}
        go={go}
        Icon={
          <>
            <BsGraphUp size={20} className="text-black" />
          </>
        }
      />
      <LiDev
        name={'Configuración'}
        to={`/cashier/config`}
        pathName={pathName}
        go={go}
        Icon={
          <>
            <GrConfigure size={20} className="text-black" />
          </>
        }
      />      
      <LiDev
        name={"Academia"}
        to="/aprender"
        pathName={pathName}
        go={go}
        Icon={<SiHtmlacademy size={20} className="text-black" />}
      />
      {(enableRoutes.includes("*") || enableRoutes.includes("/admin")) && (
        <LiDev
        name={t("sidebar.admin")}
        to="/admin"
        pathName={pathName}
        go={go}
        Icon={
          <>
            <BsFillKeyFill size={20} className="text-black" />
          </>
        }
      />
      )}
        <LiDev
          name={t("exit")}
          to="/salir"
          pathName={pathName}
          go={go}
          Icon={
            <>
              <MdOutlineLogout size={20} className="text-black" />
            </>
          }
        />
      
    </ul>
  </div>
  )
}

type ParamsLiDev = {
  name: string,
  to: string,
  Icon: any,
  pathName: any,
  go(to:string): void
}
const LiDev = ({ name, to, Icon, pathName, go}: ParamsLiDev) => {
  return (
    <li>
      <div
        className={classNames(
          pathName.toString().includes(to)
          ? 'bg-[#f3f4f6] border-l-green-admin-light' 
          :
           'md:bg-transparent border-l-transparent',
          "transition-all border-l-transparent border-l-8 flex md:flex-row items-center justify-start  text-black py-2 px-8 cursor-pointer font-semibold w-full md:w-64"
          
        )}
        onClick={() => go(to)}
      >
        <div className="flex flex-wrap flex-col text-black items-center text-xs text-center">
          {Icon}
        </div>
        <div className="flex  font-medium px-2 text-xs md:text-sm opensans  text-black">
          {name}
        </div>
      </div>
    </li>
  );
};
